<template>
  <div id="date-picker-wrapper" class="form-inline">
    <div class="input-group-sm form-control">
      <date-pick
        :value="value.format(DATE_FORMAT)"
        @input="handleInput"

        class="date-picker__general-size date-picker__disable-clear"
        :is-date-disabled="isFutureDate"
        :months="monthsNames"
        :weekdays="daysNames"
        :input-attributes="{ readonly: true }"
        :format="DATE_FORMAT"
      />
    </div>
  </div>
</template>

<script>
import DatePick from 'vue-date-pick';
import 'vue-date-pick/dist/vueDatePick.css';
import moment from 'moment';

const DATE_FORMAT = 'DD/MM/YYYY';

export default {
  props: {
    value: {
      required: true,
    },

    theMaxRestrictionDate: {
      type: [moment, null],
      required: false,
    },
  },

  components: {
    DatePick,
  },

  data: () => ({
    DATE_FORMAT,
  }),

  computed: {
    monthsNames() {
      return this.$store.state.utils.months;
    },

    daysNames() {
      return this.$store.state.utils.daysShort;
    },

    theLastAvailableDate() {
      if (this.theMaxRestrictionDate) {
        return this.theMaxRestrictionDate;
      }

      return moment().subtract(1, 'days');
    },
  },

  methods: {
    handleInput(date) {
      if (!date) {
        return;
      }

      this.$emit('input', moment(date, DATE_FORMAT));
    },

    isFutureDate(date) {
      return date > this.theLastAvailableDate.toDate();
    },
  },
}
</script>

<style>
#date-picker-wrapper {
  display: inline;
}

.date-picker__general-size > input {
  font-size: 16px;
  min-width: 90px;
}

.date-picker__disable-clear > .vdpClearInput {
  display: none;
}

.vdpComponent.vdpWithInput > input {
  font-size: 16px;
  width: 74px;
  border: 0;
  padding-right: 0;
}
.vdpComponent.vdpWithInput>input {
  padding-right: 0!important;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/VectorWidgets/ux/DatePicker.vue